var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessTables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,10 H42 V34 H6 Z",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,14 H38 V30 H10 Z",
    fill: "#00D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,17 A5,5 0,1 0,24,27 A5,5 0,1 0,24,17",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3,18 V26 H23.3 V23.2 H20.7 V21.3 H23.3 V18 Z",
    fill: "#0D0D12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8,34 H13 V42 H9 Z M35,34 H40 L39,42 H35 Z",
    fill: "#FFD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessTables);
export default __webpack_public_path__ + "static/media/p4r_business_tables.de98ab3e34fda2103f12b06875e63376.svg";
export { ForwardRef as ReactComponent };